'use strict';

var size = require('../../size.js');

var width = {
  'width-0': {
    value: size.size[0]
  },
  'width-025': {
    value: size.size['025']
  },
  'width-050': {
    value: size.size['050']
  },
  'width-100': {
    value: size.size[100]
  },
  'width-150': {
    value: size.size[150]
  },
  'width-200': {
    value: size.size[200]
  },
  'width-300': {
    value: size.size[300]
  },
  'width-400': {
    value: size.size[400]
  },
  'width-500': {
    value: size.size[500]
  },
  'width-600': {
    value: size.size[600]
  },
  'width-700': {
    value: size.size[700]
  },
  'width-800': {
    value: size.size[800]
  },
  'width-900': {
    value: size.size[900]
  },
  'width-1000': {
    value: size.size[1000]
  },
  'width-1200': {
    value: size.size[1200]
  },
  'width-1600': {
    value: size.size[1600]
  },
  'width-2000': {
    value: size.size[2000]
  },
  'width-2400': {
    value: size.size[2400]
  },
  'width-2800': {
    value: size.size[2800]
  },
  'width-3200': {
    value: size.size[3200]
  }
};

exports.width = width;
